export const appVersion = '0.29.2';
